
import React, {useEffect} from "react";
import NavBarComponent from "../../components/navBar/NavBarComponent";
import FooterComponent from "../../components/home/FooterComponent";
import CartView from "../../components/checkout/checkoutFlow/cartView";


export default function Cart() {

    return (
        <div>
            <NavBarComponent />
            <CartView />
            <FooterComponent />
        </div>
    )
}